import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Checkbox, Grid, IconButton, makeStyles } from "@material-ui/core"
import moment from "moment"
import { useTranslation } from "react-i18next"
import { setSelectedEvents } from "../../actions/eventActions"
import _ from "lodash"
import { getGraphDataRequestSuccess } from "../../actions/createTimelineActions"
import { addGraphRecord, removeGraphRecord } from "../../utils"
import { ModalPopup } from "../modal"
import EventDetails from "../event/EventDetails"
import EventMenu from "./EventMenu"
import { Skeleton } from "@material-ui/lab"

const useStyles = makeStyles((theme) => ({
	root: {
		maxHeight: 500,
		overflowY: "auto",
	},
	wrapper: {
		marginBottom: 8,
		paddingBottom: 8,
		backgroundColor: theme.palette.common.white,
	},
	heading: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
	},
	titleSection: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	title: {
		fontWeight: 400,
		width: "84%",
		textOverflow: "ellipsis",
		overflow: "hidden",
		display: "-webkit-box",
		"-webkit-line-clamp": 1,
		"-webkit-box-orient": "vertical",
		"word-break": "break-all",
	},
	paddingLeft: {
		paddingLeft: 9,
	},
	color: {
		width: 14,
		minWidth: 14,
		height: 14,
		borderRadius: 3,
		marginRight: 9,
	},
	subHeading: {
		fontSize: 12,
	},
	link: {
		color: theme.palette.primary.dark,
		position: "relative",
		display: "inline-block",
		cursor: "pointer",
		fontSize: 12,
		"&::after": {
			content: '""',
			position: "absolute",
			left: 9,
			bottom: 0,
			width: "95%",
			height: 1,
			backgroundColor: theme.palette.primary.dark,
		},
	},
}))

const Events = () => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [t] = useTranslation("global")

	const eventsList = useSelector((state) => state.events.list)
	const selectedEvents = useSelector((state) => state.events.selectedEvents)
	const graphData = useSelector((state) => state.timeline.graph)
	const isLoading = useSelector((state) => state.events.isLoading)

	const ITEM_HEIGHT = 48

	const [openEventDetailDialog, setOpenEventDetailDialog] = useState(false)
	const [eventDetails, setEventDetails] = useState({})

	const handleEventAddRemove = (event) => {
		const updatedCheckedEvents = [...selectedEvents]
		const eventIndex = updatedCheckedEvents.findIndex((item) => item.id === event.id)

		if (eventIndex === -1) {
			//not found - add it
			updatedCheckedEvents.push(event)

			const graph = addGraphRecord(graphData, event)
			dispatch(getGraphDataRequestSuccess(graph))
			// if (graphData.length !== graph.length) {
			// 	dispatch(getGraphDataRequestSuccess(graph)) //update the graph data
			// }

			//todo - we need to handle this case for outof range event
			updatedCheckedEvents?.forEach((evt) => {
				const newGraph = addGraphRecord(graph, evt)
				dispatch(getGraphDataRequestSuccess(newGraph))
			})
		} else {
			//found - remove it
			updatedCheckedEvents.splice(eventIndex, 1)

			let graph = removeGraphRecord(graphData, event)
			dispatch(getGraphDataRequestSuccess(graph))

			//todo - we need to handle this case for outof range event
			updatedCheckedEvents?.forEach((evt) => {
				const newGraph = addGraphRecord(graph, evt)
				dispatch(getGraphDataRequestSuccess(newGraph))
			})

			// if (graphData.length !== graph.length) {
			// 	//if we remove event we should also remove the record from graphData we we have entry for 0 docs
			// 	dispatch(getGraphDataRequestSuccess(graph)) //update the graph data
			// }
		}

		//setCheckedEvents(updatedCheckedEvents)
		dispatch(setSelectedEvents(updatedCheckedEvents))
	}

	const handleShowEvent = (event) => {
		setOpenEventDetailDialog(true)
		setEventDetails(event)
	}

	return (
		<div className={classes.root}>
			{isLoading ? (
				Array(6)
					.fill()
					.map((data, i) => (
						<Grid key={i} item xs={12} style={{ marginBottom: 20 }}>
							<Skeleton key={i} animation="wave" variant="rect" height={30} width="90%" style={{ marginBottom: 5 }} />
							<Skeleton key={i + 1} animation="wave" variant="rect" height={15} width="50%" style={{ marginBottom: 5 }} />
							<Skeleton key={i + 2} animation="wave" variant="rect" height={15} width="30%" />
						</Grid>
					))
			) : eventsList?.length > 0 ? (
				<>
					{eventsList?.map((event) => (
						<div id={event.id} className={classes.wrapper}>
							<div className={classes.heading}>
								<div className={classes.titleSection}>
									<Checkbox
										className={classes.checkbox}
										size="small"
										checked={selectedEvents.some((item) => item.id === event.id)}
										onChange={(e) => handleEventAddRemove(event)}
										inputProps={{ "aria-label": "primary checkbox" }}
										disableRipple={true}
									/>
									<div className={classes.color} style={{ backgroundColor: event.colour }}></div>

									<div className={classes.title} title={event.name}>
										{event.name}
									</div>
								</div>

								<EventMenu event={event} />
							</div>
							<div className={`${classes.subHeading} ${classes.paddingLeft}`}>{`${moment(event.start_date).format(
								"DD/MM/yyyy"
							)} - ${moment(event.end_date).format("DD/MM/yyyy")}`}</div>
							<div className={`${classes.link} ${classes.paddingLeft}`} onClick={() => handleShowEvent(event)}>
								{t("event.details")}
							</div>
						</div>
					))}
				</>
			) : (
				<p style={{ padding: 20 }}>{t("event.noEventsFound")}</p>
			)}

			<ModalPopup title={t("event.eventDetails")} open={openEventDetailDialog} setOpen={setOpenEventDetailDialog}>
				<EventDetails event={eventDetails} />
			</ModalPopup>
		</div>
	)
}

export default Events
